"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.portalsZIndex = exports.important = exports.PixelUnit = exports.DisabledOpacity = exports.FontSize = exports.FontFamily = exports.BoxShadow = exports.Color = void 0;
var _ = require("lodash");
/// Colors
var ColorConstants = {
    // Primary Palette
    StarRezBrandColors: {
        BlackSR: "black",
        Blue60: "#0075DB",
        Grey30: "#DAE5EC",
        Grey80: "#12374E",
        WhiteSR: "white",
        YellowSR: "#FFF100",
    },
    Grey: {
        G100: "#020F18",
        G90: "#072131",
        // tslint:disable-next-line: object-literal-sort-keys
        G80: "#12374E",
        G70: "#516878",
        G60: "#6D748D",
        G50: "#C4C9D2",
        G40: "#C8D3DA",
        G30: "#DAE5EC",
        G20: "#EDF2F5",
        G10: "#F6F8FA",
    },
    // Secondary Palette
    Blue: {
        B100: "#00398D",
        B80: "#0341E0",
        // tslint:disable-next-line: object-literal-sort-keys
        B60: "#0075DB",
        B40: "#B4E1FA",
        B20: "#EBF6FF",
    },
    Green: {
        G100: "#003A1B",
        G80: "#038215",
        // tslint:disable-next-line: object-literal-sort-keys
        G60: "#50B83C",
        G40: "#BBE5B3",
        G20: "#E3F1DF",
    },
    Orange: {
        O100: "#4A1504",
        O80: "#C05717",
        // tslint:disable-next-line: object-literal-sort-keys
        O60: "#FB7C39",
        O40: "#FFC58B",
        O20: "#FCEBDB",
    },
    Pink: {
        P100: "#58002C",
        P80: "#A21950",
        // tslint:disable-next-line: object-literal-sort-keys
        P60: "#D22866",
        P40: "#FEA0C0",
        P20: "#FFCFE2",
    },
    Purple: {
        P100: "#1F0481",
        P80: "#4319D6",
        // tslint:disable-next-line: object-literal-sort-keys
        P60: "#6A43F3",
        P40: "#DED6FC",
        P20: "#F6F0FD",
    },
    Red: {
        R100: "#4F0407",
        R80: "#A5191F",
        // tslint:disable-next-line: object-literal-sort-keys
        R60: "#E1272F",
        R40: "#FEAD9A",
        R20: "#FBEAE5",
    },
    Teal: {
        T100: "#003135",
        T80: "#00828C",
        // tslint:disable-next-line: object-literal-sort-keys
        T60: "#47C1BF",
        T40: "#B7ECEC",
        T20: "#E0F5F5",
    },
    Yellow: {
        Y100: "#573B00",
        Y80: "#8A6116",
        // tslint:disable-next-line: object-literal-sort-keys
        Y60: "#EEC200",
        Y40: "#FFF0B3",
        Y20: "#FFFBEC",
    },
};
var ColourSchemes = {
    // Primary Palette
    StarRezBrandColors: {
        BlueRegular: {
            backgroundColor: ColorConstants.StarRezBrandColors.Blue60,
            color: "white",
        },
        WhiteRegular: {
            backgroundColor: ColorConstants.StarRezBrandColors.WhiteSR,
            color: ColorConstants.StarRezBrandColors.Grey80,
        },
        // tslint:disable-next-line: object-literal-sort-keys
        GreyDarker: {
            backgroundColor: ColorConstants.StarRezBrandColors.Grey80,
            color: "white",
        },
        GreyLighter: {
            backgroundColor: ColorConstants.StarRezBrandColors.Grey30,
            color: ColorConstants.StarRezBrandColors.Grey80,
        },
        YellowRegular: {
            backgroundColor: ColorConstants.StarRezBrandColors.YellowSR,
            color: ColorConstants.StarRezBrandColors.Grey80,
        },
    },
    Grey: {
        Darkest: {
            backgroundColor: ColorConstants.Grey.G100,
            color: "white",
        },
        UltraDark: {
            backgroundColor: ColorConstants.Grey.G90,
            color: "white",
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Darker: {
            backgroundColor: ColorConstants.Grey.G80,
            color: "white",
        },
        Dark: {
            backgroundColor: ColorConstants.Grey.G70,
            color: "white",
        },
        RegularDark: {
            backgroundColor: ColorConstants.Grey.G60,
            color: "white",
        },
        RegularLight: {
            backgroundColor: ColorConstants.Grey.G50,
            color: ColorConstants.Grey.G80,
        },
        Light: {
            backgroundColor: ColorConstants.Grey.G40,
            color: ColorConstants.Grey.G80,
        },
        Lighter: {
            backgroundColor: ColorConstants.Grey.G30,
            color: ColorConstants.Grey.G80,
        },
        UltraLight: {
            backgroundColor: ColorConstants.Grey.G20,
            color: ColorConstants.Grey.G80,
        },
        Lightest: {
            backgroundColor: ColorConstants.Grey.G10,
            color: ColorConstants.Grey.G80,
        },
    },
    // Secondary Palette
    Blue: {
        Darker: {
            backgroundColor: ColorConstants.Blue.B100,
            color: "white",
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Dark: {
            backgroundColor: ColorConstants.Blue.B80,
            color: "white",
        },
        Regular: {
            backgroundColor: ColorConstants.Blue.B60,
            color: "white",
        },
        Light: {
            backgroundColor: ColorConstants.Blue.B40,
            color: ColorConstants.Blue.B100,
        },
        Lighter: {
            backgroundColor: ColorConstants.Blue.B20,
            color: ColorConstants.Blue.B100,
        },
    },
    Green: {
        Darker: {
            backgroundColor: ColorConstants.Green.G100,
            color: "white",
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Dark: {
            backgroundColor: ColorConstants.Green.G80,
            color: "white",
        },
        Regular: {
            backgroundColor: ColorConstants.Green.G60,
            color: ColorConstants.Green.G100,
        },
        Light: {
            backgroundColor: ColorConstants.Green.G40,
            color: ColorConstants.Green.G100,
        },
        Lighter: {
            backgroundColor: ColorConstants.Green.G20,
            color: ColorConstants.Green.G100,
        },
    },
    Orange: {
        Darker: {
            backgroundColor: ColorConstants.Orange.O100,
            color: "white",
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Dark: {
            backgroundColor: ColorConstants.Orange.O80,
            color: "white",
        },
        Regular: {
            backgroundColor: ColorConstants.Orange.O60,
            color: ColorConstants.Orange.O100,
        },
        Light: {
            backgroundColor: ColorConstants.Orange.O40,
            color: ColorConstants.Orange.O100,
        },
        Lighter: {
            backgroundColor: ColorConstants.Orange.O20,
            color: ColorConstants.Orange.O100,
        },
    },
    Pink: {
        Darker: {
            backgroundColor: ColorConstants.Pink.P100,
            color: "white",
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Dark: {
            backgroundColor: ColorConstants.Pink.P80,
            color: "white",
        },
        Regular: {
            backgroundColor: ColorConstants.Pink.P60,
            color: "white",
        },
        Light: {
            backgroundColor: ColorConstants.Pink.P40,
            color: ColorConstants.Pink.P100,
        },
        Lighter: {
            backgroundColor: ColorConstants.Pink.P20,
            color: ColorConstants.Pink.P100,
        },
    },
    Purple: {
        Darker: {
            backgroundColor: ColorConstants.Purple.P100,
            color: "white",
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Dark: {
            backgroundColor: ColorConstants.Purple.P80,
            color: "white",
        },
        Regular: {
            backgroundColor: ColorConstants.Purple.P60,
            color: "white",
        },
        Light: {
            backgroundColor: ColorConstants.Purple.P40,
            color: ColorConstants.Purple.P100,
        },
        Lighter: {
            backgroundColor: ColorConstants.Purple.P20,
            color: ColorConstants.Grey.G80,
        },
    },
    Red: {
        Darker: {
            backgroundColor: ColorConstants.Red.R100,
            color: "white",
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Dark: {
            backgroundColor: ColorConstants.Red.R80,
            color: "white",
        },
        Regular: {
            backgroundColor: ColorConstants.Red.R60,
            color: "white",
        },
        Light: {
            backgroundColor: ColorConstants.Red.R40,
            color: ColorConstants.Red.R100,
        },
        Lighter: {
            backgroundColor: ColorConstants.Red.R20,
            color: ColorConstants.Red.R100,
        },
    },
    Teal: {
        Darker: {
            backgroundColor: ColorConstants.Teal.T100,
            color: "white",
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Dark: {
            backgroundColor: ColorConstants.Teal.T80,
            color: "white",
        },
        Regular: {
            backgroundColor: ColorConstants.Teal.T60,
            color: ColorConstants.Teal.T100,
        },
        Light: {
            backgroundColor: ColorConstants.Teal.T40,
            color: ColorConstants.Teal.T100,
        },
        Lighter: {
            backgroundColor: ColorConstants.Teal.T20,
            color: ColorConstants.Teal.T100,
        },
    },
    Yellow: {
        Darker: {
            backgroundColor: ColorConstants.Yellow.Y100,
            color: "white",
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Dark: {
            backgroundColor: ColorConstants.Yellow.Y80,
            color: "white",
        },
        Regular: {
            backgroundColor: ColorConstants.Yellow.Y60,
            color: ColorConstants.Yellow.Y100,
        },
        Light: {
            backgroundColor: ColorConstants.Yellow.Y40,
            color: ColorConstants.Yellow.Y100,
        },
        Lighter: {
            backgroundColor: ColorConstants.Yellow.Y20,
            color: ColorConstants.Yellow.Y100,
        },
    },
};
exports.Color = _.merge(ColorConstants, ColourSchemes);
var boxShadows = {
    Box30: "0px 2px 30px rgba(0, 0, 0, 0.1)",
};
exports.BoxShadow = boxShadows;
// Typography
exports.FontFamily = "Roboto, Arial, Helvetica, sans-serif";
exports.FontSize = "14px!important";
// Misc
exports.DisabledOpacity = "0.4";
var BasePixelUnit = "8px"; // 8 point system base unit is 8px
var PixelUnit = function (n) { return "calc(" + BasePixelUnit + " * " + n + ")"; };
exports.PixelUnit = PixelUnit;
// Buttons:
var fontSize = "14px!important;";
var letterSpacing = "0.25px;";
var letterSpacingCaps = "0.93px";
var fontSizeCaps = "13px!important";
var buttonFont = {
    "font-family": exports.FontFamily,
    "font-size": fontSize,
    "font-weight": "bold!important;",
    "letter-spacing": letterSpacing,
};
var buttonBase = {
    "align-items": "center;",
    "border": "none;",
    "border-radius": "5px;",
    "box-sizing": "border-box",
    "cursor": "pointer;",
    "display": "inline-flex;",
    "height": "40px;",
    "justify-content": "center;",
    "transition": "all ease-in-out 0.15s;",
    "vertical-align": "top;",
    "white-space": "nowrap;",
};
var important = function (style) {
    return style + " !important";
};
exports.important = important;
exports.portalsZIndex = 100000;
exports.default = {
    Buttons: {
        ButtonBase: buttonBase,
        FontBase: buttonFont,
        DisabledOpacity: "0.4",
    },
    Text: {
        Color: exports.important(exports.Color.Grey.G80),
        FontSize: fontSize,
        LetterSpacing: letterSpacing,
    },
    Thumbnail: {
        BackgroundColor: exports.Color.Blue.B60,
        Color: "white",
        SquareBorderRadius: "4px",
    },
    UppercaseText: {
        FontSize: fontSizeCaps,
        LetterSpacing: letterSpacingCaps,
    },
    DropList: {
        BorderColour: exports.Color.Grey.G30,
        HoverBackgroundColor: exports.important(exports.Color.Grey.G10),
        HoverColor: exports.important(exports.Color.Grey.G80),
        ImportantHoverBackgroundColor: exports.important(exports.Color.Red.R60),
        ImportantHoverColor: exports.important("white"),
        RowHeight: "30px",
    },
};
